import React, { useContext } from "react";
import { ListItem as MuiListItem, Badge as MuiBadge, ListItemIcon, ListItemText, makeStyles, withStyles } from "@material-ui/core";
import { useHistory, useLocation } from "react-router-dom";

import { NavContext } from "./sidebarNav";

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
    },
    label: {
        color: "var(--text-medium)",
        fontFamily: "Arial",
        fontSize: "16px",
        fontWeight: "bold",
    },
}));

const ListItem = withStyles({
    root: {
        "&.Mui-selected": {
            backgroundColor: "white",
            borderLeft: "4px solid var(--blue-bell)",
            paddingLeft: "12px",
        },
    },
})(MuiListItem);

const Badge = withStyles({
    badge: {
        backgroundColor: "var(--text-error)",
        color: "white",
    },
})(MuiBadge);

const SidebarNavLink = (props) => {
    const { icon: Icon, caption, index, path, badge } = props;
    const classes = useStyles();
    const navCtx = useContext(NavContext);
    const history = useHistory();
    const location = useLocation();

    const { open } = navCtx;

    var listItemSelected = open ? " selected-open" : " selected-close";

    const selectedStyle = (isSelected) => ({
        style: {
            fontWeight: isSelected ? "700" : "400",
            color: isSelected ? "var(--blue-bell)" : "var(--text-medium)",
        },
    });

    const isSelected = location.pathname === path;

    return (
        <ListItem
            className={"sidebar-hover" + (isSelected ? listItemSelected : "")}
            button
            key={"Overview"}
            selected={isSelected}
            onClick={() => {
                history.push(path);
            }}>
            <ListItemIcon>
                {badge && badge > 0 ? (
                    <Badge badgeContent={badge}>
                        <Icon color={isSelected && !open ? "white" : "var(--blue-bell)"} />
                    </Badge>
                ) : (
                    <Icon color={isSelected && !open ? "white" : "var(--blue-bell)"} />
                )}
            </ListItemIcon>
            <ListItemText
                classes={{
                    root: classes.label,
                }}
                primary={caption}
                primaryTypographyProps={selectedStyle(isSelected)}
            />
        </ListItem>
    );
};

export default SidebarNavLink;
